import ChevronUpIcon from 'heroicons/solid/chevron-up.svg'

export default {
  components: { ChevronUpIcon },

  props: {
    isOpen: { type: Boolean, required: true },
  },

  render() {
    return (
      <button class="block focus:outline-none" on={this.$listeners} tabindex="-1">
        <ChevronUpIcon
          class={`h-5 w-5 transform transition-all duration-200 ease-in-out ${
            this.isOpen ? '' : 'rotate-180'
          }`}
        />
      </button>
    )
  },
}
